<template>
    <div>
      <hr style="background-color: #2E8037; height: 1px ;border: #2E8037"/>
    </div>
</template>

<script>
export default {
  name: 'line-hr',
};
</script>

<style scoped>

</style>
